const whyChooseContent = {
  title: "Why choose Gaia Powered?",
  description: "We believe that switching to renewable energy should be easy, affordable and beneficial for both you and the planet. Our mission is to provide seamless, high-quality renewable solutions that lower energy costs while reducing your carbon footprint. With expert guidance, flexible financing and sustainable technology we make going green simple and rewarding.",
  items: [
    {
      title: "Lower Energy Bills",
      description: "Slash your energy costs by switching to a heat pump. Our efficient systems use renewable energy to keep your home warm while reducing reliance on expensive fossil fuels.",
      icon: ""
    },
    {
      title: "Eco-Friendly & Sustainable",
      description: "Lower your carbon footprint with our renewable heating solutions. Heat pumps provide clean, green energy, reducing emissions while keeping your home comfortable.",
      icon: ""
    },
    {
      title: "Expert Installation & Support",
      description: "Our certified professionals handle everything - from consultation to installation - ensuring a hassle-free experience. Plus we offer ongoing support for peace of mind.",
      icon: ""
    },
    {
      title: "Affordable Pricing & Financing",
      description: "With grants and flexible financing, making the switch is easier than ever. Get a high-quality heat pump for as little as £2,500 with available government incentives.",
      icon: ""
    }
  ]
}

  // Journey steps
const journeySteps = [
  {
    number: "01",
    title: "Get an instant online estimate.",
    description: "Answer a few quick questions to receive an immediate, no-obligation estimate for your home."
  },
  {
    number: "02",
    title: "Design consultation and system planning.",
    description: "Speak with our heat pump design team to discuss your home, energy needs, and options. We guide you clearly through the process."
  },
  {
    number: "03",
    title: "Technical design, costing, and survey.",
    description: "We complete a tailored system design, provide a clear cost breakdown, and carry out a final in-home survey to confirm everything before installation."
  },
  {
    number: "04",
    title: "Installation and handover.",
    description: "Our certified team installs your heat pump and shows you how to use the system efficiently and confidently."
  }
]

export { whyChooseContent, journeySteps }